export const APP_BASEPATH = '/tools'
